module.exports = __webpack_public_path__ + "img/no_zone.da92cd85.svg";